/*
 *
 * ReportHeader reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_MEDITIONS_SUCCESS,
  GET_MEDITIONS_WATCHER,
  GET_MEDITIONS_FAILED,
  OFFICIALIZE_MEDITIONS_SUCCESS,
  OFFICIALIZE_MEDITIONS_WATCHER,
  OFFICIALIZE_MEDITIONS_FAILED,
  SET_CURRENT_MEDITION,
  MEDITIONS_ACTIONS_WATCHER,
  MEDITIONS_ACTIONS_SUCCESS,
  MEDITIONS_ACTIONS_FAILED,
} from "./constants"

export const initialState = fromJS({
  loadingMeditions: true,
  meditions: [],
  all_meditions: [],
  isEmptyMeditions: true,
  officializeLoading: false,
  officialize: false,
  ambassador_count: 0,
  current_medition: {},
  available_actions: {
    is_loading: false,
    is_exportable: false,
    is_action_plan_creatable: false,
    is_officializable: false,
  },
})

function reportHeaderReducer(state = initialState, action) {
  switch (action.type) {
    case GET_MEDITIONS_WATCHER:
      return state
        .set("loadingMeditions", true)
        .set("meditions", [])
        .set("all_meditions", [])
        .set("ambassador_count", 0)
        .set("isEmptyMeditions", true)
    case GET_MEDITIONS_SUCCESS:
      return state
        .set("loadingMeditions", false)
        .set("meditions", action.payload.meditions)
        .set("ambassador_count", action.payload.ambassador_count)
        .set("all_meditions", action.payload.allMeditions)
        .set("isEmptyMeditions", action.payload.isEmptyMeditions)
    case GET_MEDITIONS_FAILED:
      return state.set("loadingMeditions", false)
    case OFFICIALIZE_MEDITIONS_WATCHER:
      return state.set("officializeLoading", true)
    case OFFICIALIZE_MEDITIONS_SUCCESS:
      return state.set("officializeLoading", false).set("officialize", true)

    case OFFICIALIZE_MEDITIONS_FAILED:
      return state.set("officializeLoading", false).set("officialize", false)

    case SET_CURRENT_MEDITION:
      return state.set("current_medition", action.payload)

    case MEDITIONS_ACTIONS_WATCHER:
      return state.set("available_actions", {
        is_loading: true,
        is_exportable: false,
        is_action_plan_creatable: false,
        is_officializable: false,
      })
    case MEDITIONS_ACTIONS_FAILED:
      return state.set("available_actions", {
        is_loading: false,
        is_exportable: false,
        is_action_plan_creatable: false,
        is_officializable: false,
      })
    case MEDITIONS_ACTIONS_SUCCESS:
      return state.set("available_actions", {
        is_loading: false,
        ...action.payload,
      })

    default:
      return state
  }
}

export default reportHeaderReducer
